import * as React from 'react'
import { useTabActions, useTabData, tabStyles, useEditLocation } from './hooks'
import { MatchCreateNewTabsProps } from './typings'
import { CreateNew } from './CreateNew'
import { Match } from './Match'
import { SettingsPage, Tab, TabPanel } from '@sales-center/components'
import { AddServiceLocationDrawer } from '../AddServiceLocationForm'
import Divider from '@mui/material/Divider'
import Tabs from '@mui/material/Tabs'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useCreateMatchSave } from './hooks'

const getStyles = () => ({
  footer: { width: '100%' },
  progress: { width: '100%' },

  button: {
    display: 'block',
    float: 'right',
    margin: 0,
    marginLeft: 'auto',
    marginRight: '16px',
    height: '36px',
    alignSelf: 'center',
  },
})

export const MatchCreateNewTabs: React.FC<MatchCreateNewTabsProps> = (
  props,
) => {
  const styles = getStyles()
  const validatedLocations = useTabData()
  const { tab, onChangeTab } = useTabActions()

  const [formState, formDispatch, onCloseForm] = useEditLocation()

  const { onSave, disableSave, ...rest } = useCreateMatchSave({
    ...props,
    ...validatedLocations,
    formDispatch,
    tab,
  })

  const { matchLocationTitle } = props

  return (
    <SettingsPage
      title="Match / Create New Location"
      headContent={
        <>
          <Box>
            <Tabs value={tab} onChange={onChangeTab}>
              <Tab label={matchLocationTitle} />
              <Tab label="Create New Location" />
              <Button
                onClick={onSave}
                disabled={disableSave}
                sx={styles.button}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </Tabs>
          </Box>
          <Divider />
        </>
      }
      padding="0"
      fullScreen
    >
      <TabPanel tab={tab} value={0} sx={tabStyles.tabPanel}>
        <Match
          {...props}
          {...rest}
          {...validatedLocations}
          formDispatch={formDispatch}
        />
      </TabPanel>
      <TabPanel tab={tab} value={1} sx={tabStyles.tabPanel}>
        <CreateNew
          {...props}
          {...validatedLocations}
          formDispatch={formDispatch}
        />
      </TabPanel>
      <AddServiceLocationDrawer
        {...props}
        {...formState}
        onClose={onCloseForm}
        externalLocation={false}
        matchUpdateMode
        newExternalLocation
      />
    </SettingsPage>
  )
}
MatchCreateNewTabs.displayName = 'MatchCreateNewTabs'
